import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/omkar07070/portfolio'
      className='link footer__link'
      target='_blank'
      rel='noreferrer'
    >
      Created By Omkar Indalkar
    </a>
  </footer>
)

export default Footer
